import { MonogramCircle, MonogramRounded, MonogramSquare } from '@economist/design-system/dist/umd/common';
import * as React from 'react';
export default {
  MonogramCircle,
  MonogramRounded,
  MonogramSquare,
  React
};